import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=4ef660a4&scoped=true&"
import script from "./CardBase.vue?vue&type=script&lang=js&"
export * from "./CardBase.vue?vue&type=script&lang=js&"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=4ef660a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef660a4",
  null
  
)

export default component.exports